import React from 'react';
import { Box, Card, Text, Title } from '@nimbus-ds/components';

function DefenseInfoSkeleton(): JSX.Element {
  return (
    <Card>
      <Card.Header>
        <Title.Skeleton as="h3" />
      </Card.Header>
      <Card.Body>
        <Box display="flex" flexDirection="column" gap="2">
          <Text.Skeleton />
          <Text.Skeleton width="75%" />
          <Text.Skeleton width="50%" />
        </Box>
      </Card.Body>
    </Card>
  );
}

export default DefenseInfoSkeleton;
